"use strict";

const { pageViewEvent } = require("../helpers/gtmHelpers");

module.exports = function () {
    pageViewEvent("Customer Support");
};
